<h1 mat-dialog-title class="dialog-title">Remove units</h1>

<div mat-dialog-content class="dialog-content">
  <p class="dialog-description">
    @if (isFullRemoval) {
      Changing Property Sub Type to <strong>{{ data.propertySubType | enumRef: 'propertySubType' }}</strong> removes all
      <strong>{{ data.units.length }}</strong> unit{{ data.units.length === 1 ? '' : 's' }} from the primary structure.
    } @else {
      Changing Property Sub Type to <strong>{{ data.propertySubType | enumRef: 'propertySubType' }}</strong> requires
      removing exactly <strong>{{ data.removalCount }}</strong> unit{{ data.removalCount === 1 ? '' : 's' }}. Select the
      unit{{ data.removalCount === 1 ? '' : 's' }}
      to remove.
    }
  </p>

  <div class="unit-card-list">
    @for (unit of data.units; track unit.id) {
      <label
        class="unit-card"
        [class.unit-card--selected]="selectedUnitIds.has(unit.id)"
        [class.unit-card--locked]="isFullRemoval"
      >
        <mat-checkbox
          [checked]="selectedUnitIds.has(unit.id)"
          [disabled]="isFullRemoval"
          (change)="toggleUnit(unit.id, $event.checked)"
        >
        </mat-checkbox>
        <div class="unit-card__body">
          <span class="unit-card__name">Unit {{ $index + 1 }}</span>
          <span class="unit-card__meta">
            Beds: {{ (unit.BedroomsTotal | selectedSourceData) ?? '-' }} | Baths:
            {{ (unit.BathroomsFullCalculated | selectedSourceData) ?? 0 }}.{{
              (unit.BathroomsHalfCalculated | selectedSourceData) ?? 0
            }}
            | Rooms: {{ (unit.RoomsTotal | selectedSourceData) ?? '-' }}
          </span>
        </div>
      </label>
    }
  </div>
</div>

<div mat-dialog-actions class="dialog-footer">
  <span
    class="dialog-footer__counter"
    [class.dialog-footer__counter--match]="selectedUnitIds.size === data.removalCount"
    [class.dialog-footer__counter--over]="selectedUnitIds.size > data.removalCount"
  >
    {{ selectedUnitIds.size }} of {{ data.removalCount }} unit{{ data.removalCount === 1 ? '' : 's' }} selected
  </span>
  <div class="dialog-footer__actions">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button type="button" color="warn" [disabled]="!canConfirm" (click)="confirm()">
      Remove {{ data.removalCount }} unit{{ data.removalCount === 1 ? '' : 's' }}
    </button>
  </div>
</div>
